import { useState, useCallback } from 'react'

const ANIM_DURATION = 300

export default function useAlerts () {
  const [alerts, setAlerts] = useState([])

  // const pushAlert = useCallback(({ type, message }) => {
  //   const id = Date.now() + Math.random()
  //   setAlerts(a => [...a, { id, type, message, open: true }])
  // }, [])

    const pushAlert = useCallback(({ type, message }) => {
    setAlerts(prev => {
      const id = Date.now() + Math.random();
      const next = [...prev, { id, type, message, open: true }];
      return next.slice(-3);          //  ←  hard-limit in state
    });
  }, []);

  const closeAlert = useCallback(id => {
    // trigger slide-out
    setAlerts(a => a.map(x => (x.id === id ? { ...x, open: false } : x)))
    // remove after the animation
    setTimeout(() => {
      setAlerts(a => a.filter(x => x.id !== id))
    }, ANIM_DURATION)
  }, [])

  const showValidationErrors = useCallback(
    errors => {
      const errs = Object.values(errors).reverse()
      if (!alerts.length) {
        errs.forEach(e => pushAlert({ type: 'error', message: e.message }))
      } else {
        // slide out all old
        setAlerts(a => a.map(x => ({ ...x, open: false })))
        // then slide in new
        setTimeout(() => {
          errs.forEach(e => pushAlert({ type: 'error', message: e.message }))
        }, ANIM_DURATION)
      }
    },
    [alerts.length, pushAlert]
  )

  return { alerts, pushAlert, closeAlert, showValidationErrors }
}
